export const includePrefixedRoutes = (prefix, routes) => {
  return routes.map((route) => {
    return {
      ...route,
      path: `${prefix.trim()}/${route.path.trim()}`.replace(/\/\/+/g, "/"),
    };
  });
}
